import { connect } from "react-redux";
import actionCreators from "../redux/actionCreators";
import { getFilterText, getShowNames } from "../redux/selectors";
import RowActionsPanel from "./rowActionsPanel";
import { Permissions, security } from "Common/permissions";
const canEdit = security.isAllowed([Permissions.OntologicalModelEdit]);
const mapStateToProps = (state) => ({
    showNames: getShowNames(state),
    filterText: getFilterText(state),
    canEdit
});
const mapDispatchToProps = (dispatch) => ({
    onSetShowNames: (showNames) => dispatch(actionCreators.setShowNames(showNames)),
    onChangeFilterText: (filterText) => dispatch(actionCreators.setFilterText(filterText)),
    onDownload: () => {
        dispatch(actionCreators.download());
    },
    onUpload: (file) => {
        dispatch(actionCreators.upload(file));
    },
    onReloadOntology: () => {
        dispatch(actionCreators.reloadOntology());
    },
    onExportOntology: () => {
        dispatch(actionCreators.exportOntology());
    }
});
export default connect(mapStateToProps, mapDispatchToProps)(RowActionsPanel);
